import React, { useEffect, useState } from 'react'
import Accordion from '../../../../components/accordion/Accordion'
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown'
import commonStyles from "../ManageForms.styles"
import RichGrid from '../../../../components/richgrid/RichGrid'
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants'
import { componentKey, setBlockReconciliationData, setBlockReconciliationModal, setCheckForStateFrequencyPopup, setPaginationState, setReconciliationGridData, setReconciliationSelectedForms, setReconciliationStateList, setSelectedReconciliationFormStates, setSelectedStateWitheldPaymentFrequency, setShowStateWitheldPaymentFrequencyPopup, setBlockReconciliationSuccess, setPayerDropdownPagination } from './ManageReconciliationFormsSlice'
import { useDispatch, useSelector } from 'react-redux'
import Label from '../../../../components/label/Label'
import Button from '../../../../components/button/Button'
import { LABEL_WEIGHT } from '../../../../components/label/constants'
import { blockReconciliation, getReconFrequencyPopUpOption, getReconGridData, getReconPayer, getReconStatesbyPayer, getReconciliationPDF } from './ManageReconciliationFormsSaga'
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook'
import ReconciliationFormSubmitPopup from '../../../components/reconciliationformsubmitpopup/ReconciliationFormSubmitPopup'
import { FREQUENCY_POPUP_HEADER } from '../../reconciliation/constants'
import commonFormStyles from '../../FormSection.styles';
import RadioInput from '../../../../components/input/radioinput/RadioInput'
import Popup from '../../../../components/popup/Popup'
import { QUERY_PARAMS } from '../../constants'
import IconDropdown from '../../../../components/dropdown/icondropdown/IconDropdown'
import useFormatTIN from '../../../../../libs/customhooks/useFormatTIN'
import Loadable from '../../../../components/loadable/Loadable'
import { MANAGE_FORMS_LOADING_STATES, MANAGE_RECONCILIATION_LOADING_STATES, MANAGE_RECONCILIATION_LOADING_STATES_MESSAGE_MAP } from '../constants'
import styles from './ ManageReconciliationForms.styles'

const ManageReconciliationForms = ({ federalTaxYear }) => {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const [isReconciliationFormSubmitPopupOpen, setIsReconciliationFormSubmitPopupOpen] = useState(false);
    const [selectedRowForReconciliation, setSelectedRowForReconciliation] = useState(null);

    const { formatTIN } = useFormatTIN()

    const { loadingState, paginationState, reconciliationSelectedForms, reconciliationFormStates, reconciliationPayerList, reconciliationStateList, reconciliationGridData, blockReconciliationData, blockReconciliationModal, stateWitheldPaymentFrequency, showStateWitheldPaymentFrequencyPopup, checkForStateFrequencyPopup, selectedStateWitheldPaymentFrequency, blockReconciliationSuccess, payerDropdownPagination } = useSelector(state => state[componentKey])

    const [paginatedPayerList, setPaginatedPayerList] = useState([]);
    useEffect(() => {
        setPaginatedPayerList(reconciliationPayerList)
    }, [reconciliationPayerList])

    useEffect(() => {
        const urlPayerId = queryParams.get(QUERY_PARAMS.PAYER_ID);
        dispatch(getReconPayer({ urlPayerId }));
    }, []);

    useEffect(() => {
        const urlTaxYear = queryParams.get(QUERY_PARAMS.TAX_YEAR);

        if (urlTaxYear) {
            const taxYear = federalTaxYear.find(year => year?.value == urlTaxYear);
            if (taxYear) {
                dispatch(setSelectedReconciliationFormStates({ name: "ReconciliationTaxYear", value: taxYear }))
            }
        }

    }, [federalTaxYear])

    useEffect(() => {
        if (reconciliationFormStates.ReconciliationPayer.value !== "") {
            dispatch(setReconciliationStateList([]));
            dispatch(setReconciliationGridData([]));
            dispatch(setSelectedReconciliationFormStates({ name: "ReconciliationState", value: { value: "", label: "" } }));
            let urlStateId = queryParams.get(QUERY_PARAMS.STATE_ID);
            dispatch(getReconStatesbyPayer({ payerId: reconciliationFormStates.ReconciliationPayer.value, urlStateId }))
        }
    }, [reconciliationFormStates.ReconciliationPayer])

    useEffect(() => {
        if (reconciliationFormStates.ReconciliationPayer.value !== "" && reconciliationFormStates.ReconciliationTaxYear.value !== "" && reconciliationFormStates.ReconciliationState.value !== "") {
            dispatch(getReconGridData({ payerId: reconciliationFormStates.ReconciliationPayer.value, taxYear: reconciliationFormStates.ReconciliationTaxYear.value, state: reconciliationFormStates.ReconciliationState.value, PageNumber: paginationState.PageNumber, PageSize: paginationState.PageSize }))
        }
    }, [reconciliationFormStates.ReconciliationState, paginationState.PageNumber, paginationState.PageSize])

    useEffect(() => {
        if (blockReconciliationSuccess) {
            dispatch(getReconGridData({ payerId: reconciliationFormStates.ReconciliationPayer.value, taxYear: reconciliationFormStates.ReconciliationTaxYear.value, state: reconciliationFormStates.ReconciliationState.value, PageNumber: paginationState.PageNumber, PageSize: paginationState.PageSize }))
            dispatch(setBlockReconciliationSuccess(false))
        }
    }, [blockReconciliationSuccess, paginationState.PageNumber, paginationState.PageSize])

    useEffect(() => {
        if (checkForStateFrequencyPopup) {
            if (stateWitheldPaymentFrequency[selectedRowForReconciliation?.ReconFormType]) {
                dispatch(setShowStateWitheldPaymentFrequencyPopup(true));
            } else {
                setIsReconciliationFormSubmitPopupOpen(true);
            }
            dispatch(setCheckForStateFrequencyPopup(false));
        }
    }, [checkForStateFrequencyPopup]);

    const handleEditReconciliationBtnClk = (row) => {
        setSelectedRowForReconciliation(row);
        dispatch(getReconFrequencyPopUpOption({
            state: row?.State,
            reconFormid: row?.FormRecordId,
        }))
    }

    const MANAGE_RECONCILIATION_FORM_COLUMN = [
        {
            field: "ReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>Reference No.</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row.ReferenceNumber || "-"}</span>
        },
        {
            field: "FormName",
            header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.FormName || "-"}</span>
        },
        {
            field: "State",
            header: <Label weight={LABEL_WEIGHT[700]}>State</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.State || "-"}</span>
        },
        {
            field: "TaxYear",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax Year</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.TaxYear || "-"}</span>
        },
        {
            field: "TaxId",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax ID</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row?.TINType, row.TIN) || "-"}</span>
        },
        {
            field: "StateAccountId",
            header: <Label weight={LABEL_WEIGHT[700]}>State Account ID</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.StateAccountId || "-"}</span>
        },
        {
            field: "Status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.Status || "-"}</span>
        },
        {
            field: "action",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Action</Label >,
            renderLogic: (row, idx) => {
                const ACTIONS_MENU_OPTIONS = [
                    ...(row?.ScheduledDate ? [{
                        itemName: "Edit Reconciliation",
                        onClick: () => {
                            handleEditReconciliationBtnClk(row)
                        },
                        styles: commonStyles.prmiaryText,
                    }] : []),
                    {
                        itemName: "View PDF",
                        onClick: () => {
                            dispatch(getReconciliationPDF({ reconFormId: row.FormRecordId, reconState: row.State, formName: row.ReconFormType }))
                        },
                        styles: commonStyles.prmiaryText,
                    },
                    ...(row?.ScheduledDate ? [{
                        itemName: "Block",
                        onClick: () => {
                            dispatch(setBlockReconciliationModal(true))
                            dispatch(setBlockReconciliationData(row))
                        },
                        styles: commonStyles.prmiaryText,
                    }] : []),
                ]

                return <div style={commonStyles.actionButtons}>
                    <IconDropdown
                        iconName={VEC_ICON_NAME.THREE_DOT_MENU_ICON}
                        showToggle={false}
                        label=""
                        dropdownItems={ACTIONS_MENU_OPTIONS}
                        dropdownMenuStyle={commonStyles.menuItemsDropdown}
                    />
                </div>
            }
        },
    ];

    const Body = (
        <div>
            <div style={commonStyles.selectDropdown}>
                <Loadable currentState={loadingState.state} loadingStates={[MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]} isNewLoadable={true} isFullWidth={false}>
                    <SelectDropdown
                        label="Payer *"
                        name="ReconciliationPayer"
                        placeHolder="Select a payer"
                        onSelectCb={(name, selectedOption) => {
                            dispatch(setSelectedReconciliationFormStates({ name: [name], value: selectedOption }))

                            if (selectedOption?.value) {
                                queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                            } else {
                                queryParams.delete(QUERY_PARAMS.PAYER_ID)
                            }
                            setQueryParams(queryParams);
                            dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                        }}
                        options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                        onDropdownTouchedToBottomCb={() => {
                            if (payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length) {
                                dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                            }
                        }}
                        value={reconciliationFormStates.ReconciliationPayer}
                    />
                </Loadable>
                <SelectDropdown
                    label="Tax Year *"
                    name="ReconciliationTaxYear"
                    placeHolder="Select tax year"
                    options={federalTaxYear}
                    onSelectCb={(name, selectedOption) => {
                        dispatch(setSelectedReconciliationFormStates({ name: [name], value: selectedOption }))

                        if (selectedOption?.value) {
                            queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                        } else {
                            queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                        }
                        setQueryParams(queryParams);
                        dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                    }}
                    value={reconciliationFormStates.ReconciliationTaxYear}
                />

                <Loadable currentState={loadingState.state} loadingStates={[MANAGE_RECONCILIATION_LOADING_STATES.RECON_STATES_LOADING]} messageMap={MANAGE_RECONCILIATION_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                    <SelectDropdown
                        label="State *"
                        name="ReconciliationState"
                        placeHolder="Select state"
                        options={reconciliationStateList}
                        onSelectCb={(name, selectedOption) => {
                            dispatch(setSelectedReconciliationFormStates({ name: [name], value: selectedOption }))

                            if (selectedOption?.value) {
                                queryParams.set(QUERY_PARAMS.STATE_ID, selectedOption?.value)
                            } else {
                                queryParams.delete(QUERY_PARAMS.STATE_ID)
                            }
                            setQueryParams(queryParams);
                            dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                        }}
                        value={reconciliationFormStates.ReconciliationState}
                    />
                </Loadable>
            </div>

            <div style={styles.reconciliationGridContainer}>
                <Loadable currentState={loadingState.state} loadingStates={[MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_LOADING]} messageMap={MANAGE_RECONCILIATION_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                    <RichGrid
                        data={reconciliationGridData}
                        columns={MANAGE_RECONCILIATION_FORM_COLUMN}
                        extractRowKey={(row) => row.ReferenceNumber}
                        selectedRows={reconciliationSelectedForms}
                        onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setReconciliationSelectedForms(selectedData))}
                        onSelectionChangeCallBack={(selectedData) => dispatch(setReconciliationSelectedForms(selectedData))}
                        paginationProps={{
                            skip: paginationState?.Skip,
                            take: paginationState?.PageSize,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            total: paginationState?.totalRecipients,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            },
                            onChange: (take, skip) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                            }
                        }}
                    />
                </Loadable>
            </div>

            <ConfirmationPopup title='Are you sure?'
                bodyText={`Are you sure you want to block ${blockReconciliationData?.State} state filing?`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={blockReconciliationModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(blockReconciliation({ FormId: blockReconciliationData?.FormRecordId, State: blockReconciliationData?.State, formName: blockReconciliationData?.FormName }))
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setBlockReconciliationModal(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />
        </div>
    )

    return (
        <>
            <div>
                <Accordion header={'State Reconciliation'} body={Body} active={true} />
            </div>
            {isReconciliationFormSubmitPopupOpen && <ReconciliationFormSubmitPopup
                isPopupOpen={isReconciliationFormSubmitPopupOpen}
                title={`Form ${selectedRowForReconciliation?.ReconFormType}`}
                formId={selectedRowForReconciliation?.ReconFormType}
                handlePopupClose={() => setIsReconciliationFormSubmitPopupOpen(false)}
                onFinalSubmitCb={() => { dispatch(getReconGridData({ payerId: reconciliationFormStates.ReconciliationPayer.value, taxYear: reconciliationFormStates.ReconciliationTaxYear.value, state: reconciliationFormStates.ReconciliationState.value, PageNumber: paginationState.PageNumber, PageSize: paginationState.PageSize })) }}
                isEditModeOn={(selectedRowForReconciliation?.FormRecordId && selectedRowForReconciliation?.FormRecordId != "0") ? true : false}
                taxYear={selectedRowForReconciliation?.TaxYear}
                reconciliationPayerId={selectedRowForReconciliation?.EncryptedPayerId}
                reconciliationState={selectedRowForReconciliation?.State}
                formRecordId={(selectedRowForReconciliation?.FormRecordId && selectedRowForReconciliation?.FormRecordId != "0") ? selectedRowForReconciliation?.FormRecordId : 0}
                referenceId={selectedRowForReconciliation?.ReferenceNumber}
                quarter={selectedStateWitheldPaymentFrequency}
            />
            }
            {showStateWitheldPaymentFrequencyPopup && <Popup
                title={FREQUENCY_POPUP_HEADER}
                showClose={false}
                isPopupOpen={showStateWitheldPaymentFrequencyPopup}
            >
                <div style={commonFormStyles.frequencyPopupBody}>
                    <div style={commonFormStyles.frequencyPopupPaddingTen}>
                        {stateWitheldPaymentFrequency[selectedRowForReconciliation?.ReconFormType]?.map(frequency =>
                            <RadioInput label={{ suffixLabel: frequency.label }} value={frequency.id} checked={selectedStateWitheldPaymentFrequency === frequency.id} onChangeCb={(e) => dispatch(setSelectedStateWitheldPaymentFrequency(frequency.id))} />
                        )
                        }
                    </div>
                    <div style={commonFormStyles.frequencyPopupFooter}>
                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => {
                            if (selectedStateWitheldPaymentFrequency !== "") {
                                setIsReconciliationFormSubmitPopupOpen(true);
                                dispatch(setShowStateWitheldPaymentFrequencyPopup(false))
                            } else {
                                dispatch(addNotifications({
                                    heading: "Error",
                                    message: SELECT_PAYMENT_FREQUENCY,
                                    variant: TOASTER_VARIANT.WARNING,
                                }))
                            }
                        }}>Confirm</Button>
                        <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => {
                            dispatch(setSelectedStateWitheldPaymentFrequency(""));
                            dispatch(setShowStateWitheldPaymentFrequencyPopup(false));
                        }} >Cancel</Button>
                    </div>
                </div>
            </Popup>
            }
        </>
    )
}

export default ManageReconciliationForms
